import { Middleware, AnyAction } from 'redux';
import { oc } from 'ts-optchain';
import { isActionOfType } from './utils';
import { AUTHENTICATE_LOGOUT } from './authentication/actions';

let SESSION_ID = 1;
const SESSION_ID_KEY = '__SESSION_ID__';

const isReduxAxiosRequestAction = (action: AnyAction) =>
  action && action.payload && action.payload.request;

const isReduxAxiosResponseAction = (action: AnyAction) =>
  action &&
  action.meta &&
  action.meta.previousAction &&
  isReduxAxiosRequestAction(action.meta.previousAction);

export const attachSessionIdMiddleware: Middleware = () => next => action => {
  if (isActionOfType([AUTHENTICATE_LOGOUT], action)) {
    SESSION_ID += 1;
  }

  if (isReduxAxiosRequestAction(action)) {
    Object.assign(action, { meta: { [SESSION_ID_KEY]: SESSION_ID, ...action.meta } });

    return next(action);
  }

  return next(action);
};

/* eslint-disable-next-line  consistent-return */
export const validateSessionIdMiddleware: Middleware = () => next => action => {
  if (isReduxAxiosResponseAction(action)) {
    if (oc(action).meta.previousAction.meta[SESSION_ID_KEY](0) === SESSION_ID) {
      return next(action);
    }
  } else {
    return next(action);
  }
};
